import { createSlice } from '@reduxjs/toolkit';
import { brandBuilderInitialState } from './initialState';
import {
  getCities,
  getBrandBaanEntitiesList,
  addBrandBaanEntitiy,
  getIndustriesList,
  getSectorsList,
  addBrandBaanDepartment,
  getBrandBaanCompetitiors,
  getBrandBaanCompetitiorSuggestions,
  removeBrandBaanCompetitior,
  addBrandBaanCompetitior,
  editBrandBaanEntity,
  removeBrandBaanEntity,
  addBrandBaanProfilesOrSubject,
  activeBrandBaanEntity,
  searchDigikalaBrands,
} from './actions';
import { citiesAdapter } from './brandBuilder.adapters';

const isCurrentDigikalaSearch = (state, action) =>
  action.meta.requestId === state.digikalaBrandsSearch.pendingRequestId;

export const brandBuilderSlice = createSlice({
  name: 'brandBuilderSlice',
  initialState: brandBuilderInitialState,
  reducers: {
    resetDigikalaBrandsSearch: (state) => {
      state.digikalaBrandsSearch =
        brandBuilderInitialState.digikalaBrandsSearch;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCities.fulfilled, (state, action) => {
        state.cities.data = citiesAdapter(action.payload);
        state.cities.loading = false;
        state.cities.error = null;
      })
      .addCase(getCities.pending, (state) => {
        state.cities.loading = true;
        state.cities.error = null;
      })
      .addCase(getCities.rejected, (state, action) => {
        state.cities.loading = false;
        state.cities.error = action.payload;
      })
      .addCase(getIndustriesList.fulfilled, (state, action) => {
        state.industries.data = action.payload;
        state.industries.loading = false;
        state.industries.error = null;
      })
      .addCase(getIndustriesList.pending, (state) => {
        state.industries.loading = true;
        state.industries.error = null;
      })
      .addCase(getIndustriesList.rejected, (state, action) => {
        state.industries.loading = false;
        state.industries.error = action.payload;
      })
      .addCase(getSectorsList.fulfilled, (state, action) => {
        state.sectors.data = action.payload;
        state.sectors.loading = false;
        state.sectors.error = null;
      })
      .addCase(getSectorsList.pending, (state) => {
        state.sectors.loading = true;
        state.sectors.error = null;
      })
      .addCase(getSectorsList.rejected, (state, action) => {
        state.sectors.loading = false;
        state.sectors.error = action.payload;
      })
      .addCase(getBrandBaanEntitiesList.fulfilled, (state, action) => {
        state.entitiesList.data = action.payload.data;
        state.entitiesList.total = action.payload.meta.total;
        state.entitiesList.loading = false;
        state.entitiesList.error = null;
      })
      .addCase(getBrandBaanEntitiesList.pending, (state) => {
        state.entitiesList.loading = true;
        state.entitiesList.error = null;
      })
      .addCase(getBrandBaanEntitiesList.rejected, (state, action) => {
        state.entitiesList.loading = false;
        state.entitiesList.error = action.payload;
      })
      .addCase(addBrandBaanEntitiy.fulfilled, (state, action) => {
        state.createEntity.data = action.payload;
        state.createEntity.loading = false;
        state.createEntity.error = null;
      })
      .addCase(addBrandBaanEntitiy.pending, (state) => {
        state.createEntity.loading = true;
        state.createEntity.error = null;
      })
      .addCase(addBrandBaanEntitiy.rejected, (state, action) => {
        state.createEntity.loading = false;
        state.createEntity.error = action.payload;
      })
      .addCase(addBrandBaanProfilesOrSubject.fulfilled, (state, action) => {
        state.shareEntity.data = action.payload;
        state.shareEntity.loading = false;
        state.shareEntity.error = null;
      })
      .addCase(addBrandBaanProfilesOrSubject.pending, (state) => {
        state.shareEntity.loading = true;
        state.shareEntity.error = null;
      })
      .addCase(addBrandBaanProfilesOrSubject.rejected, (state, action) => {
        state.shareEntity.loading = false;
        state.shareEntity.error = action.payload;
      })
      .addCase(editBrandBaanEntity.fulfilled, (state) => {
        state.editEntity.data = null;
        state.editEntity.loading = false;
        state.editEntity.error = null;
      })
      .addCase(editBrandBaanEntity.pending, (state) => {
        state.editEntity.loading = true;
        state.editEntity.error = null;
      })
      .addCase(editBrandBaanEntity.rejected, (state, action) => {
        state.editEntity.loading = false;
        state.editEntity.error = action.payload;
      })
      .addCase(removeBrandBaanEntity.fulfilled, (state) => {
        state.removeEntity.data = null;
        state.removeEntity.loading = false;
        state.removeEntity.error = null;
      })
      .addCase(removeBrandBaanEntity.pending, (state) => {
        state.removeEntity.loading = true;
        state.removeEntity.error = null;
      })
      .addCase(removeBrandBaanEntity.rejected, (state, action) => {
        state.removeEntity.loading = false;
        state.removeEntity.error = action.payload;
      })
      .addCase(addBrandBaanDepartment.fulfilled, (state, action) => {
        state.brandDepartment.data = action.payload;
        state.brandDepartment.loading = false;
        state.brandDepartment.error = null;
      })
      .addCase(addBrandBaanDepartment.pending, (state) => {
        state.brandDepartment.loading = true;
        state.brandDepartment.error = null;
      })
      .addCase(addBrandBaanDepartment.rejected, (state, action) => {
        state.brandDepartment.loading = false;
        state.brandDepartment.error = action.payload;
      })
      .addCase(getBrandBaanCompetitiors.fulfilled, (state, action) => {
        state.brandCompetitiors.data = action.payload;
        state.brandCompetitiors.loading = false;
        state.brandCompetitiors.error = null;
      })
      .addCase(getBrandBaanCompetitiors.pending, (state) => {
        state.brandCompetitiors.loading = true;
        state.brandCompetitiors.error = null;
      })
      .addCase(getBrandBaanCompetitiors.rejected, (state, action) => {
        state.brandCompetitiors.loading = false;
        state.brandCompetitiors.error = action.payload;
      })
      .addCase(
        getBrandBaanCompetitiorSuggestions.fulfilled,
        (state, action) => {
          state.brandCompetitiorSuggestions.data = action.payload.data;
          state.brandCompetitiorSuggestions.total = action.payload.meta.total;
          state.brandCompetitiorSuggestions.loading = false;
          state.brandCompetitiorSuggestions.error = null;
        }
      )
      .addCase(getBrandBaanCompetitiorSuggestions.pending, (state) => {
        state.brandCompetitiorSuggestions.loading = true;
        state.brandCompetitiorSuggestions.error = null;
      })
      .addCase(getBrandBaanCompetitiorSuggestions.rejected, (state, action) => {
        state.brandCompetitiorSuggestions.loading = false;
        state.brandCompetitiorSuggestions.error = action.payload;
      })
      .addCase(removeBrandBaanCompetitior.fulfilled, (state, action) => {
        state.removeBrandCompetitior.data = action.payload;
        state.removeBrandCompetitior.loading = false;
        state.removeBrandCompetitior.error = null;
      })
      .addCase(removeBrandBaanCompetitior.pending, (state) => {
        state.removeBrandCompetitior.loading = true;
        state.removeBrandCompetitior.error = null;
      })
      .addCase(removeBrandBaanCompetitior.rejected, (state, action) => {
        state.removeBrandCompetitior.loading = false;
        state.removeBrandCompetitior.error = action.payload;
      })
      .addCase(addBrandBaanCompetitior.fulfilled, (state, action) => {
        state.addBrandCompetitior.data = action.payload.data;
        state.addBrandCompetitior.loading = false;
        state.addBrandCompetitior.error = null;
      })
      .addCase(addBrandBaanCompetitior.pending, (state) => {
        state.addBrandCompetitior.loading = true;
        state.addBrandCompetitior.error = null;
      })
      .addCase(addBrandBaanCompetitior.rejected, (state, action) => {
        state.addBrandCompetitior.loading = false;
        state.addBrandCompetitior.error = action.payload;
      })
      .addCase(activeBrandBaanEntity.fulfilled, (state, action) => {
        state.activeEntity.data = action.payload.data;
        state.activeEntity.loading = false;
        state.activeEntity.error = null;
      })
      .addCase(activeBrandBaanEntity.pending, (state) => {
        state.activeEntity.loading = true;
        state.activeEntity.error = null;
      })
      .addCase(activeBrandBaanEntity.rejected, (state, action) => {
        state.activeEntity.loading = false;
        state.activeEntity.error = action.payload;
      })
      .addCase(searchDigikalaBrands.pending, (state, action) => {
        state.digikalaBrandsSearch.pendingRequestId = action.meta.requestId;
        state.digikalaBrandsSearch.loading = true;
        state.digikalaBrandsSearch.error = null;
      })
      .addCase(searchDigikalaBrands.fulfilled, (state, action) => {
        if (!isCurrentDigikalaSearch(state, action)) return;
        state.digikalaBrandsSearch.data = action.payload || [];
        state.digikalaBrandsSearch.loading = false;
        state.digikalaBrandsSearch.error = null;
      })
      .addCase(searchDigikalaBrands.rejected, (state, action) => {
        if (!isCurrentDigikalaSearch(state, action)) return;
        state.digikalaBrandsSearch.loading = false;
        state.digikalaBrandsSearch.error = action.payload;
      });
  },
});

export const { resetDigikalaBrandsSearch } = brandBuilderSlice.actions;
